
export default (uuid) => {
  return uuid.split('-')[0]
}
